import { useAuth } from '@/hooks/useApi'
import { useTenantContext } from '@/contexts/TenantContext'

interface TenantGuardProps {
  children: React.ReactNode
}

export function TenantGuard({ children }: TenantGuardProps) {
  const { isSuperAdmin } = useAuth();
  const { selectedTenantId, isResolvingSubdomain } = useTenantContext();
  
  // If resolving subdomain, show loading
  if (isResolvingSubdomain) {
    return (
      <div className="p-6">
        <div className="text-center py-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Loading...</h2>
          <p className="text-gray-600">Resolving tenant information...</p>
        </div>
      </div>
    )
  }
  
  // If user is super admin but hasn't selected a tenant, show message
  if (isSuperAdmin && !selectedTenantId) {
    return (
      <div className="p-6">
        <div className="text-center py-12">
          <h2 className="text-2xl font-bold text-gray-900 mb-2">Select Tenant</h2>
          <p className="text-gray-600">Please select a tenant from the dropdown above to access this section.</p>
        </div>
      </div>
    )
  }
  
  // Otherwise, render the protected content
  return <>{children}</>
}